import React from 'react'
import colours from '../../../assets/theme/colours'
import typography from '../../../assets/theme/typography'
import playStoreButtonImage from '../../../assets/images/googlePlayButtonImage75.webp'
import appStoreButtonImage from '../../../assets/images/appStoreButtonImage75.webp'
import phoneScreen from '../../../assets/images/phoneAboutApp75.webp'
import { LazyComponent } from '../../../components/LazyComponent'
import { isBrowser } from 'react-device-detect'

const AboutSection = () => {

  return (
    <div style={{
      backgroundColor: colours.blockColor1,
      width: '100%',
      paddingBottom: '7vw',
      marginTop: isBrowser ? -10 : -25,
      zIndex: 1,
    }}>
      <div
        style={{
          ...typography.paragraph,
          color: colours.primaryFont,
          padding: '5vw 10vw',
          display: 'flex',
          flexDirection: 'row',
          gap: isBrowser ? '10vw' : '4vw',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: 2,
            gap: '1.5vw'
          }}
        >
          <p style={{ fontSize: '2vw', margin: 0, fontWeight:  700 }}>ABOUT THE APP</p>
          <p style={{ fontSize: '1.4vw', margin: 0, fontWeight: 400 }}>
                        Live updates of fuel price changes, economic factors and fuel
                        price predictions. View the current petrol and diesel prices in South Africa. Wholesale
                        diesel
                        prices are quoted. Prices vary between fuel retailers. This should help you to better plan
                        your
                        next top up. This app is ad free and at no cost for a limited time only. Please share this
                        app
                        if you like it. Remember to rate the app.
          </p>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: isBrowser ? '2vw' : '',
              marginLeft: '-1.1vw',
            }}
          >
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <img
                src={playStoreButtonImage}
                alt="Google Play"
                style={{
                  maxHeight: '10vh',
                  cursor: 'pointer',
                  width: !isBrowser ? '95px' : '',
                  height: !isBrowser ? '39px' : '',
                }}
                tabIndex={0}
                onClick={() =>
                  window.open(
                    'https://play.google.com/store/apps/details?id=za.co.runninghill.safuelprice&hl=en_ZA&pli=1',
                    '_blank')}
              />
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <img
                src={appStoreButtonImage}
                alt="App Store"
                style={{
                  maxHeight: '7.8vh',
                  cursor: 'pointer',
                  width: !isBrowser ? '86px' : '',
                  height: !isBrowser ? '30px' : '',
                }}
                onClick={() => window.open('https://apps.apple.com/au/app/sa-fuel-price/id808858230', '_blank')}
                tabIndex={0}
              />
            </div>
          </div>
          <p style={isBrowser ? { fontWeight: 500, fontSize: 20, fontStyle: 'italic' } :
            { margin: 0, fontWeight: 400, fontSize: 10 }}>
            Free
          </p>
        </div>
        <div style={{ marginTop: '-15vw', zIndex: 2 }}>
          <img
            src={phoneScreen}
            alt="phoneScreen"
            style={{
              width: isBrowser ? '30vw' : '20vw',
              aspectRatio: 1 / 2,
            }}
          />
        </div>
      </div>
      <LazyComponent componentGetter={() => import('../../../components/advertisingBanner')} />
    </div>
  )
}

export default AboutSection
